/**
 * The aim Decide suggests for a changed family: what every moved sub-field's direction points to (the catalog entry's `aims`), when they all point to the
 * same one. A move with no clear purpose, or moves that disagree, suggest nothing and the player picks.
 */
import type { DecisionCatalogEntry } from "@bsim/contracts";
import type { Decisions, DecisionFamily, Objective } from "@bsim/domain";
import { changedDecisions, readDecision, sameValue } from "./decisionValues";

export function suggestedAim(entries: readonly DecisionCatalogEntry[], family: DecisionFamily, now: Decisions, was: Partial<Decisions>): Objective | null {
  const aims = new Set<Objective | undefined>();
  for (const entry of changedDecisions(entries, family, now, was)) {
    for (const [sub, options] of Object.entries(entry.options)) {
      const before = readDecision(was, entry.decisionId, sub);
      const after = readDecision(now, entry.decisionId, sub);
      if (before === undefined || after === undefined || sameValue(before, after)) continue;
      const index = (v: typeof before) => options.findIndex((o) => sameValue(o.value, v));
      aims.add(entry.aims?.[sub]?.[index(after) > index(before) ? "up" : "down"]);
    }
  }
  const [only] = aims;
  return aims.size === 1 && only !== undefined ? only : null;
}
